<template>
  <div class="home_banner d-flex-column align-start gap-24">
    <div
      class="d-flex-row justify-start justify-sm-center"
      style="min-height: 36px; max-height: 36px"
    >
      <playstation />
      <windows />
      <mobile />
      <xbox />
      <steamdeck />
      <Switch />
    </div>

    <div
      class="d-flex-column gap-0 align-start align-sm-center"
      style="min-height: 121px"
    >
      <h1 class="t-white font-family-1 title-h1 f-w-600 boosting_market_title">
        <b class="t-light-orange font-family-1 title-h1 f-w-600">
          {{ $t("missed.boosting_market") }} <br />
        </b>
        {{ $t("missed.elevate_boosting_market") }}
      </h1>
    </div>

    <div
      class="d-flex-row justify-start md-row-to-col align-md-start"
      v-if="!$isMobile()"
    >
      <LazyBannersReviewBanner type="reviewio" :reviews="3084" />
      <LazyBannersReviewBanner type="trustpilot" :reviews="trustpilotReviews" />
    </div>
    <div
      class="d-flex-row"
      style="min-height: 38px; max-height: 38px"
      v-if="$isMobile()"
    >
      <LazyBannersMobileReviewBanner type="reviewio" :reviews="3084" />
    </div>
    <div
      class="d-flex-row"
      style="min-height: 38px; max-height: 38px"
      v-if="$isMobile()"
    >
      <button
        class="font-family-1 medium-xxl primary filled large full-width max-width-213px b-radius-6 gap-10 select_game_button"
        @click.stop="scrollToGames"
      >
        {{ $t("app.select_game_1") }} {{ $t("app.select_game_2") }}
        <LazyIconsDoubleChev />
      </button>
    </div>
  </div>
</template>

<script setup>
import Playstation from "../icons/platforms/Playstation.vue";
import Windows from "../icons/platforms/Windows.vue";
import Mobile from "../icons/platforms/Mobile.vue";
import Xbox from "../icons/platforms/Xbox.vue";
import Steamdeck from "../icons/platforms/Steamdeck.vue";
import Switch from "../icons/platforms/Switch.vue";
import { ref } from "vue";

const trustpilotReviews = ref(0);
const { getLocale } = useFunctions();

const fetchData = async () => {
  try {
    const { data: response } = await useApiPost("/api/get-trustpilot-stats", {
      method: "post",
      body: {
        locale: getLocale(),
      },
      lazy: true,
    });
    if (response) {
      trustpilotReviews.value = response?.stats?.number_of_reviews || 0;
    }
  } catch (error) {
    console.log(error);
  }
};
fetchData();

const scrollToGames = () => {
  const el = document.querySelector(".select_game_text");
  if (!el) {
    return;
  }
  el.scrollIntoView({
    behavior: "smooth",
  });
};
</script>
